import { TuiNotification } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-not-found-page',
  imports: [TuiNotification],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundPageComponent {}
